import { AppRoutes } from './routes';
import { RootErrorBoundary } from './components/app/RootErrorBoundary';

export function App() {
  return (
    <RootErrorBoundary>
      <AppRoutes />
    </RootErrorBoundary>
  );
}
